/**
 * Return the chart data for the output NOI
 *
 * @param  {Object} state
 * @return {Object}
 */
const outputChartData = state => state.data.output.noi.reduce((result, i) => {
    result.labels.push(i.label)
    result.data.push(i.amount)
    return result
}, { labels: [], data: [] })

export default {
    outputChartData
}



// WEBPACK FOOTER //
// ./src/state/modules/pnl-importer/getters.js